import * as React from 'react';

import Grid from '@mui/material/Grid';

import flyclops from '@app/imageAssets/homePage/flyclops.png';
import playMechanix from '@app/imageAssets/homePage/play-mechanix.png';
import tether from '@app/imageAssets/homePage/tether.png';

type TJSXReturn = () => JSX.Element;

export const FeaturedPartners: TJSXReturn = (): JSX.Element => (
  <Grid
    container={true}
    justifyContent={'center'}
    className="home-page__featured-partners-container"
  >
    <Grid item={true} xs={10} lg={8}>
      <div className="home-page__featured-partners-header">Featured partners</div>
    </Grid>

    <Grid item={true} xs={10} lg={8} className="home-page__featured-partners-img-container">
      <img
        src={flyclops}
        className="home-page__featured-partners-logo"
        alt="Flyclops a Skillz featured partner"
      />

      <img
        src={playMechanix}
        className="home-page__featured-partners-logo"
        alt="Play Mechanix a Skillz featured partner"
      />

      <img
        src={tether}
        className="home-page__featured-partners-logo"
        alt="Tether a Skillz featured partner"
      />
    </Grid>
  </Grid>
);
